import { type ReactNode } from 'react';
import { Disclaimer } from '@repo/design-system-kit';
import { FormattedMessage, useIntl } from 'react-intl';
import { PepRadioButton, type PepRadioButtonProps } from '../pep-radio-button';

export interface PepWithDisclaimerProps extends PepRadioButtonProps {
  disclaimerMessage?: string;
}

export function PepWithDisclaimer({
  className,
  disclaimerMessage,
  title,
  subtitle,
  ...props
}: PepWithDisclaimerProps): ReactNode {
  const { formatMessage } = useIntl();

  return (
    <div className={className} data-testid="pep-with-disclaimer">
      <PepRadioButton
        className={props.value ? 'mb-16' : undefined}
        subtitle={subtitle || formatMessage({ id: 'shared-kit.pep-with-disclaimer.description' })}
        title={title || formatMessage({ id: 'shared-kit.pep-with-disclaimer.title' })}
        {...props}
      />

      {props.value ? (
        <Disclaimer.Block level="info">
          {disclaimerMessage || <FormattedMessage id="shared-kit.pep-with-disclaimer.disclaimer" />}
        </Disclaimer.Block>
      ) : null}
    </div>
  );
}
